import { type FunctionComponent } from 'react';
import { Disclosure, DisclosureContent, useDisclosureState } from 'reakit/Disclosure';

import { type FaqItemData } from '../api/cx-api.service';

import { answerContent, chevronSvg, item, questionButton, questionText } from './FaqItem.style';

type FaqItemProps = FaqItemData & { initiallyOpen: boolean };

export const FaqItem: FunctionComponent<FaqItemProps> = ({ answer, id, initiallyOpen, question }) => {
  const disclosure = useDisclosureState({ animated: 300, baseId: id, visible: initiallyOpen });

  return (
    <div className={item}>
      <Disclosure {...disclosure} as="button" className={questionButton}>
        <span className={questionText}>{question}</span>
        <svg
          aria-hidden="true"
          className={chevronSvg}
          data-open={String(disclosure.visible)}
          fill="none"
          height="24"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          width="24"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </Disclosure>
      <DisclosureContent {...disclosure} className={answerContent}>
        <div dangerouslySetInnerHTML={{ __html: answer }} />
      </DisclosureContent>
    </div>
  );
};
